import service from '@/store/services/postProRetoucher-service';

const state = {
    doneAdmin: {},
    orderBroken: {},
    doneAdminForCustomer: {},
    rejectedAdmin: {},
    writeRejected: {},
    reDoneAdmin: {},
    sendComment:{},
    waitForDownloadPhoto:{}
};

const mutations = {
    SET_DONE_ADMIN: (state, doneAdmin) => {
        state.doneAdmin = doneAdmin;
    },
    SET_ORDER_BROKEN: (state, orderBroken) => {
        state.orderBroken = orderBroken;
    },
    SET_DONE_ADMIN_FOR_CUSTOMER: (state, doneAdminForCustomer) => {
        state.doneAdminForCustomer = doneAdminForCustomer;
    },
    SET_WAIT_FOR_DOWNLOAD_PHOTO: (state, waitForDownloadPhoto) => {
        state.waitForDownloadPhoto = waitForDownloadPhoto;
    },
    SET_REJECTED_ADMIN: (state, rejectedAdmin) => {
        state.rejectedAdmin = rejectedAdmin;
    },
    SET_WRITE_REJECTED: (state, writeRejected) => {
        state.writeRejected = writeRejected;
    },
    SET_RE_DONE_ADMIN: (state, reDoneAdmin) => {
        state.reDoneAdmin = reDoneAdmin;
    },
    SET_SEND_COMMENT: (state, sendComment) => {
        state.sendComment = sendComment;
    },

};
const actions = {
    doneAdmin({commit, dispatch}, params) {
        return service.doneAdmin(params)
            .then(({doneAdmin}) => {
                commit('SET_DONE_ADMIN', doneAdmin);
            });
    },
    orderBroken({commit, dispatch}, params) {
        return service.orderBroken(params)
            .then(({orderBroken}) => {
                commit('SET_ORDER_BROKEN', orderBroken);
            });
    },
    doneAdminForCustomer({commit, dispatch}, params) {
        return service.doneAdminForCustomer(params)
            .then(({doneAdminForCustomer}) => {
                commit('SET_DONE_ADMIN_FOR_CUSTOMER', doneAdminForCustomer);
            });
    },
    waitForDownloadPhoto ({commit, dispatch}, params) {
        return service.waitForDownloadPhoto(params)
            .then(({doneAdminForCustomer}) => {
                commit('SET_WAIT_FOR_DOWNLOAD_PHOTO', waitForDownloadPhoto);
            });
    },
    rejectedAdmin({commit, dispatch}, params) {
        return service.rejectedAdmin(params)
            .then(({rejectedAdmin}) => {
                commit('SET_REJECTED_ADMIN', rejectedAdmin);
            });
    },
    writeRejected({commit, dispatch}, params) {
        return service.writeRejected(params)
            .then(({writeRejected}) => {
                commit('SET_WRITE_REJECTED', writeRejected);
            });
    },
    reDoneAdmin({commit, dispatch}, params) {
        return service.reDoneAdmin(params)
            .then(({reDoneAdmin}) => {
                commit('SET_RE_DONE_ADMIN', reDoneAdmin);
            });
    },
    sendComment({commit, dispatch}, params) {
        return service.sendComment(params)
            .then(({sendComment}) => {
                commit('SET_SEND_COMMENT', sendComment);
            });
    },


};
const getters = {
    doneAdmin: state => state.doneAdmin,
    doneAdminForCustomer: state => state.doneAdminForCustomer,
    waitForDownloadPhoto: state => state.waitForDownloadPhoto,
    rejectedAdmin: state => state.rejectedAdmin,
    writeRejected: state => state.writeRejected,
    reDoneAdmin: state => state.reDoneAdmin,
    orderBroken: state => state.orderBroken,
    sendComment: state => state.sendComment
};

const postProRetoucher = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default postProRetoucher;